import { render, staticRenderFns } from "./footerBtm.vue?vue&type=template&id=7ed6b30d&scoped=true"
import script from "./footerBtm.vue?vue&type=script&lang=js"
export * from "./footerBtm.vue?vue&type=script&lang=js"
import style0 from "./footerBtm.vue?vue&type=style&index=0&id=7ed6b30d&prod&lang=scss&scoped=true"
import style1 from "./footerBtm.vue?vue&type=style&index=1&id=7ed6b30d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6b30d",
  null
  
)

export default component.exports